// extracted by mini-css-extract-plugin
module.exports = {"chart":"styles_chart__dcb5B"};